export enum Locale {
    EN = 'en',
}
